module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAARCAYAAADUryzEAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABISURBVHgB7Y6xDQAgCAQfK0tHcQRLS0dxdDdA7CmIFFpwyYWEwOeBQIWZi9gst0lbEtGScUIGnE3GNyFTrLjB1eDpcxY7AhMbebM4g4ZFoOcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-wh-05.png
// module id = oeIB
// module chunks = 1